import styled from "styled-components"
import { media } from "../../../../../styles"

export const NewsletterContainer = styled.div``
export const NewsletterText = styled.div``
export const NewsletterHeading = styled.div`
  color: var(--color-white);
  font-family: var(--font-heading);
  font-size: var(--font-size-newsletter-heading);

  margin-bottom: 2rem;
`
export const NewsletterBody = styled.p`
  color: var(--color-white);
  font-family: var(--font-body);
  font-size: var(--font-size-bodyL);

  margin-bottom: 5rem;
`

export const NewsletterForm = styled.form`
  display: flex;
  width: 100%;
  position: relative;

  & button {
    max-width: 30rem;
    margin-left: 3rem;

    margin-top: none;
    max-height: 100%;

    ${media.tabport`
    max-width: 40rem;
    margin-left: 0;
  `}
  }

  ${media.tabport`
  flex-direction: column;
  `}
`
export const NewsletterInput = styled.input`
  font-family: var(--font-body);
  font-size: var(--font-size-bodyL);
  padding: 1.5rem 0.5rem;

  border-radius: 0.6rem;
  border: none;

  width: 100%;
  max-width: 40rem;
  box-sizing: border-box;

  box-shadow: inset 0px 0px 0px 1px var(--color-white);
  border: solid 2px var(--color-white);

  padding-left: 1rem;

  & :focus {
    outline: none;
    border: solid 2px var(--color-green);

    box-shadow: inset 0px 0px 0px 1px var(--color-green);
  }

  ${media.tabport`
 margin-bottom: 2.5rem;
  `}

  ${media.phone`
  margin-bottom: 2rem;
  `}
`
export const NewsletterLabel = styled.label`
  font-family: var(--font-body);
  font-size: var(--font-size-bodyM);
  color: var(--color-white);

  font-weight: 500;

  position: absolute;
  top: -2.5rem;
`
